export default __webpack_public_path__ + "static/media/Chetanresume.0a3b77a6.doc";